export const facebookPagesByRetailerSelector = (state) =>
  (state.facebookPages && state.facebookPages.byRetailerId) || {}
